"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDrawerContext = exports.DrawerContextProvider = exports.DrawerContext = void 0;
var react_1 = __importStar(require("react"));
exports.DrawerContext = (0, react_1.createContext)(null);
var DrawerContextProvider = function (_a) {
    var children = _a.children, onClose = _a.onClose, onOpen = _a.onOpen, onClickCta = _a.onClickCta;
    var _b = (0, react_1.useState)(false), isOpen = _b[0], setIsOpen = _b[1];
    var onCloseClick = (0, react_1.useCallback)(function () {
        setIsOpen(false);
        onClose === null || onClose === void 0 ? void 0 : onClose();
    }, [onClose, setIsOpen]);
    var onOpenClick = (0, react_1.useCallback)(function () {
        setIsOpen(true);
        onOpen === null || onOpen === void 0 ? void 0 : onOpen();
    }, [setIsOpen, onOpen]);
    var onCtaClick = (0, react_1.useCallback)(function () {
        onClickCta === null || onClickCta === void 0 ? void 0 : onClickCta();
    }, [onClickCta]);
    var contextValue = (0, react_1.useMemo)(function () { return ({
        isOpen: isOpen,
        close: onCloseClick,
        open: onOpenClick,
        onCtaClick: onCtaClick,
    }); }, [isOpen, onCloseClick, onOpenClick, onCtaClick]);
    return (react_1.default.createElement(exports.DrawerContext.Provider, { value: contextValue }, children));
};
exports.DrawerContextProvider = DrawerContextProvider;
var useDrawerContext = function () {
    var context = (0, react_1.useContext)(exports.DrawerContext);
    if (!context) {
        throw new Error("useDrawerContext must be used within a DrawerContextProvider");
    }
    return context;
};
exports.useDrawerContext = useDrawerContext;
